export default {
      id: "plus-usage",
      viewBox: "0 0 256 256",
      url: "/dist/svg/" + "sprite.svg#plus-usage",
      toString: function () {
        return this.url;
      }
    }